/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_7_HInputs */

const en_privacy_7_h = /** @type {(inputs: Privacy_7_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your rights`)
};

const id_privacy_7_h = /** @type {(inputs: Privacy_7_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakmu`)
};

/**
* | output |
* | --- |
* | "Your rights" |
*
* @param {Privacy_7_HInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_7_h = /** @type {((inputs?: Privacy_7_HInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_7_HInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_7_h(inputs)
	return en_privacy_7_h(inputs)
});